module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iNM3F"))).then(() => parcelRequire('ljYL6'));